export default {
  zh: {
    congratulations: '恭喜您！',
    successPrivilege: '邮箱验证成功，您已获取',
    freeTrail: '3天免费试用！',
    checkAccount: '前往个人中心'
  },
  en: {
    congratulations: 'Congratulations！',
    successPrivilege: 'Email verified successfully, you have got ',
    freeTrail: '3 days free trial!',
    checkAccount: 'Check Your Account Info'
  }
}



// WEBPACK FOOTER //
// ./src/views/verifyEmailSuccess/lang.js